<template>
    <div
        v-if="props.title != '' && props.body != ''"
        :class="[
            'text-block',
            'text-center w-full -x',
            getAdditionalClasses(),
        ]">
        <component
            :is="getTitleTag()"
            :class="getTitleClasses()"
            v-html="props.title"></component>

        <p
            v-if="props.body"
            :class="getBodyClasses()">
            {{ props.body }}
        </p>

        <Link
            v-if="props.link"
            v-bind="props.link"></Link>
    </div>
</template>

<script lang="ts" setup>
    import { TextType } from '@/components/ComponentTypes';

    const props = defineProps<TextType>();

    const getTitleTag = () => {
        switch (props.titleTag) {
            case 'H1':
                return 'H1';
            case 'H2':
                return 'H2';
            case 'H3':
                return 'H3';
            case 'H4':
                return 'H4';
            case 'H5':
                return 'H5';
            case 'H6':
                return 'H6';
            default:
                return 'div';
        }
    };

    const getAdditionalClasses = () => {
        const classes = ['py-20'];

        if (props.type != 2) {
            classes.push('header-wrapper');
        }

        if (props.classes) {
            classes.push(props.classes);
        }

        return classes;
    };

    const getTitleClasses = () => {
        const classes = [];

        if (props.headerClasses) {
            classes.push(props.headerClasses);
        }

        if (props.titleTag === 'H1') {
            classes.push('header-main');
        } else if (props.titleTag === 'H2') {
            classes.push('header-secondary');
        }

        return classes;
    };

    const getBodyClasses = () => {
        const classes = [];

        if (props.bodyClasses) {
            classes.push(props.bodyClasses);
        }

        if (props.titleTag === 'H1' || props.titleTag === 'H2') {
            classes.push('subheading');
        }

        return classes;
    };
</script>

<style>
    .header-wrapper {
        display: flex;
        padding: 0 16px 0 16px;
        flex-direction: column;
        align-items: center;
        gap: 8px;
    }

    .header-main {
        color: var(
            --up-light-text-text-default,
            var(--text-text-default, #121212)
        );
        text-align: center;
        font-feature-settings:
            'clig' off,
            'liga' off;

        /* WEB < 900/Headline 3 */
        font-family: 'Open Sans';
        font-size: 28px;
        font-style: normal;
        font-weight: 900;
        line-height: 40px; /* 142.857% */
        letter-spacing: 0.28px;

        padding-bottom: 0;
    }

    .header-secondary {
        color: var(--up-light-text-primary, #e40032);
        font-feature-settings:
            'clig' off,
            'liga' off;

        /* WEB < 900/Headline 3 */
        font-family: 'Open Sans';
        font-size: 28px;
        font-style: normal;
        font-weight: 900;
        line-height: 40px;
        letter-spacing: 0.28px;

        padding-top: 0;
    }

    .subheading {
        align-self: stretch;

        color: var(--text-text-default, #121212);
        text-align: center;
        font-feature-settings:
            'clig' off,
            'liga' off;

        /* WEB < 900/Subtitle 3 */
        font-family: 'Open Sans';
        font-size: 18px;
        font-style: normal;
        line-height: 24px; /* 133.333% */

        margin-bottom: 16px;
    }

    .subheading--left {
        align-self: initial;
        text-align: left !important;

        color: var(--text-text-default, #121212);
        font-feature-settings:
            'clig' off,
            'liga' off;

        /* WEB < 900/Subtitle 3 */
        font-family: 'Open Sans';
        font-size: 18px;
        font-style: normal;
        line-height: 24px; /* 133.333% */
        margin-bottom: 16px;
    }
</style>
